import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import styled from "styled-components";
import theme from "../../theme";
import { Nok, PatchNokParams } from "../../types/types";
import AlertModal from "../alertModal";
import { WarningIcon } from "../../assets/icons/icons";
import { Button } from "../common/Button";
import { ModalLayout } from "../common/ModalLayout";
import { useSnackbar } from "notistack";
import { useWindowSize } from "@reactuses/core";
import InputField from "./inputField";
import usePatchNok from "../../hooks/usePatchNok";
import { useI18n } from "../../locales";

const { md } = theme.screen;

const NokModifyModal: React.FC<{
  data: Nok;
  open: boolean;
  onPressNo: () => void;
}> = (props) => {
  const { data, open, onPressNo } = props;
  const { width } = useWindowSize();
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();
  const { t } = useI18n();
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [form, setForm] = useState<PatchNokParams>({
    nok_name: data.name,
    nok_phone: data.id,
    relation: data.relation,
    seq: data.seq,
  });

  const { mutate: patchNok } = usePatchNok();

  const handlePost = () => {
    patchNok(form, {
      onSuccess: async (data) => {
        closeToModal();
        queryClient.invalidateQueries({ queryKey: ["Nok"] });
        enqueueSnackbar(t.manageNok.editSuccess, {
          variant: "success",
        });
        return data;
      },
    });
  };

  // 모달 닫기 함수
  const closeToModal = () => {
    setOpenConfirmModal(false);
    onPressNo();
  };

  // 필수 입력 조건
  const isAllFilled = [form.nok_name, form.nok_phone, form.relation].every(
    (el) => el !== ""
  );

  return (
    <ModalLayout
      open={open}
      onClose={() => setOpenConfirmModal(true)}
      width="550px"
      title={t.manageNok.editInfoTitle}
    >
      <InputField form={form} setForm={setForm} data={data} />

      <BtnWrapper>
        <Button
          onClick={() => handlePost()}
          bgColor={theme.statusColor.MAIN}
          hoverColor={theme.statusColor.MAIN_HOVER}
          disabled={!isAllFilled}
        >
          {width <= md ? t.common.save : t.manageNok.editComplete}
        </Button>
        <Button
          bgColor={theme.statusColor.CLOSE}
          onClick={() => setOpenConfirmModal(true)}
          hoverColor={theme.statusColor.CLOSE_HOVER}
        >
          {t.common.cancel}
        </Button>
      </BtnWrapper>
      <AlertModal
        open={openConfirmModal}
        onPressNo={() => setOpenConfirmModal(false)}
        title={t.manageNok.cancelEditTitle}
        content={t.manageNok.cancelEditContent}
        confirmText={t.common.confirm}
        icon={<WarningIcon />}
        onPressYes={closeToModal}
      />
    </ModalLayout>
  );
};

const BtnWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;
  margin: 0 50px;
  margin-top: 20px;

  button {
    width: 270px;
  }
  @media (max-width: ${md}px) {
    margin: 0px;
    margin-top: 20px;
  }
`;

export default NokModifyModal;
